import React, { useContext } from 'react'
import {dataContext,localestr} from '../utils.js'
import icon from '../icons.svg'

function Info({info,url}){
    const context=useContext(dataContext)
    const msg=context.msg
    const btn=[{caption:'OK',action:()=>{}}]
    if(url) btn.push({caption:localestr('Довідка'),action:()=>{
        const a = document.createElement('a')
        a.href=url
        a.target='_blank'
        a.click()
    }})

    //const stl={minWidth:width+'px',maxWidth:width*2-2+'px',display:'inherit',flexDirection:'inherit',flexShrink:'0',margin:'inherit',overflow:'hidden',transition:'max-height .3s cubic-bezier(0, 0, 1, 1) 50ms'}
    return(
        <div  tabIndex='0' style={{display:'inline',verticalAlign:'middle',marginLeft:'3px'}} title={localestr('Інформація')} 
        onClick={()=>{msg(info,localestr('Інформація'),btn)}}
        onKeyUp={(e)=>{}}><img style={{width:'18px',height:'18px'}} src={icon+'#info'} alt={localestr('Інформація')} /></div>
    )
}
export default Info